import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import TeacherService from "@/services/api/TeacherService";

export const fetchTeacherInfo = createAsyncThunk(
  "teacher/fetchTeacherInfo",
  async () => {
    const data = await TeacherService.getProfile();
    return data;
  }
);

export const updateTeacherInfo = createAsyncThunk(
  "teacher/updateTeacherInfo",
  async (formData) => {
    console.log("formData", formData);
    const data = await TeacherService.updateProfile(formData);
    return data;
  }
);

const teacherSlice = createSlice({
  name: "teacher",
  initialState: {
    teacherInfo: null,
    status: "idle",
    error: null,
  },
  reducers: {
    setTeacher(state, action) {
      state.teacherInfo = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTeacherInfo.fulfilled, (state, action) => {
        state.teacherInfo = action.payload;
        state.status = "succeeded";
      })
      .addCase(updateTeacherInfo.fulfilled, (state, action) => {
        state.teacherInfo = action.payload;
        state.status = "updated";
      })
      .addCase(fetchTeacherInfo.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      });
  },
});

export const { setTeacher } = teacherSlice.actions;

export default teacherSlice.reducer;
